var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"lesson-content"},[_c('b-card',{attrs:{"title":"ankieta"}},[_c('b-card-text',[(_vm.survey)?_c('Quiz',{attrs:{"quiz":_vm.survey,"scored":false}}):_vm._e()],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }